import React, { useMemo, useState } from "react";
import style from "./daily.module.scss";
import { Badge, Button, Card, DatePicker } from "antd";
import useRequest from "../../../utils/useRequest";
import {
    CourseItemDashBoard,
    getCoursePlanData,
    getPlatformName,
    isTrue,
    number2Hanzi,
    toNumber
} from "../../../service/service";
import LoadingWrapper from "../../../components/LoadingWrapper";
import moment from "moment";
import _ from "underscore";
import { useHistory } from "react-router-dom";
import Layout from "../components/Layout";

export default function PageDashBoardDaily() {
    const [date, setDate] = useState(moment());
    const [data, { loading }] = useRequest(
        () => getCoursePlanData(date.format("YYYY-MM-DD")),
        {},
        [date]
    );
    const sections = [1, 3, 5, 7, 9, 11, 13];

    function filterBySection(startSection: number) {
        if (!data) return [];
        return _.filter(data, item =>
            isInThisSection(
                startSection,
                startSection + 1,
                item.section,
                item.continunity
            )
        );
    }

    function isInThisSection(
        startSection: number,
        endSection: number,
        section: string,
        continunity: string
    ) {
        return (
            toNumber(section) <= endSection &&
            toNumber(section) + toNumber(continunity) - 1 >= startSection
        );
    }

    return (
        <Layout>
            <div className={style.root}>
                <LoadingWrapper loading={loading} isEmpty={!data}>
                    {() => (
                        <Card
                            title="今日课程计划"
                            extra={
                                <DatePicker
                                    defaultValue={date}
                                    onChange={value =>
                                        setDate(value || moment())
                                    }
                                />
                            }>
                            <table className={style.table}>
                                <tbody>
                                    {sections.map(section => (
                                        <CourseSection
                                            key={section}
                                            startSection={section}
                                            date={date}
                                            data={filterBySection(section)}
                                        />
                                    ))}
                                </tbody>
                            </table>
                        </Card>
                    )}
                </LoadingWrapper>
            </div>
        </Layout>
    );
}

interface CourseSectionProps {
    startSection: number;
    date: moment.Moment;
    data: CourseItemDashBoard[];
}

function CourseSection({ startSection, data, date }: CourseSectionProps) {
    const dateStr = date.format("YYYY-MM-DD");
    const history = useHistory();

    function goSection() {
        history.push(`/dashboard/section/${dateStr}/${startSection}`);
    }

    return (
        <>
            <tr>
                <td style={{ width: 160 }}>第{number2Hanzi(startSection)}节</td>
                <td rowSpan={2} className={style.textLeft}>
                    <Statics data={data} />
                </td>
                <td rowSpan={2} style={{ width: 120 }}>
                    {data.length !== 0 && (
                        <Button type="primary" ghost onClick={goSection}>
                            详情
                        </Button>
                    )}
                </td>
            </tr>

            <tr>
                <td>第{number2Hanzi(startSection + 1)}节</td>
            </tr>
        </>
    );
}

function Statics({ data }: { data: CourseItemDashBoard[] }) {
    const staticData = useMemo(() => {
        return _.groupBy(data, item => item.platformType);
    }, [data]);

    return (
        <div>
            <Badge status="warning" />
            共有{data.length}节课，有
            {_.filter(data, item => isTrue(item.isLive)).length}节直播课
            &nbsp;&nbsp;
            {data.length !== 0 && (
                <span>
                    (各平台数据：
                    {_.map(
                        staticData,
                        (item, platformType) =>
                            `${getPlatformName(platformType)}: ${
                                item.length
                            }节课`
                    ).join("、")}
                    )
                </span>
            )}
        </div>
    );
}
